<template>
  <div
    class="match-info"
    :class="`match-sport-${matchSportId}`">
    <div
      class="vertical-line"
      :class="`sport-color-${matchSportId}`"
    />
    <div class="match-info-top">
      <p class="match-display-id text-center">
        {{ matchDisplayId }}
      </p>
      <p
        class="match-status text-center"
        v-if="!isServer">
        {{ matchStatus.periodTime }}
      </p>
      <p
        class="match-name"
        :class="{ 'pad-left': isServer }">
        <span class="team">
          <transition name="slide-server">
            <i
              class="server"
              v-if="matchStatus.server === 1"
            />
          </transition>
          <transition name="slide-server">
            <span
              class="card-wrapper"
              v-if="matchStatus.redCards && matchStatus.redCards[0]">
              <i
                class="card card-single"
                v-if="matchStatus.redCards[0] === 1" />
              <i
                class="card-multiple"
                v-else>
                <i class="card card-multiple-1" />
                <i class="card card-multiple-2 text-center font-normal">
                  <span class="card-count">
                    {{ matchStatus.redCards[0] }}
                  </span>
                </i>
              </i>
            </span>
          </transition>
          <span>{{ matchTeams[0].nameShort }}</span>
        </span>
        <span class="team-separator text-center">
          {{ teamSeparator }}
        </span>
        <span class="team">
          <transition name="slide-server">
            <i
              class="server"
              v-if="matchStatus.server === 2"
            />
          </transition>
          <transition name="slide-server">
            <span
              class="card-wrapper"
              v-if="matchStatus.redCards && matchStatus.redCards[1]">
              <i
                class="card card-single"
                v-if="matchStatus.redCards[1] === 1" />
              <i
                class="card-multiple"
                v-else>
                <i class="card card-multiple-1" />
                <i class="card card-multiple-2 text-center font-normal">
                  <span class="card-count">
                    {{ matchStatus.redCards[1] }}
                  </span>
                </i>
              </i>
            </span>
          </transition>
          <span>{{ matchTeams[1].nameShort }}</span>
        </span>
      </p>
      <div class="match-info-result">
        <match-results
          :id-match="matchId"
          :id-sport="matchSportId" />
      </div>
    </div>
    <div class="match-info-bottom text-right">
      <span class="border-cover" />
      <p class="match-display-id" />
      <span class="text-upper font-italic font-bold">
        {{ matchPeriodInfo }}
      </span>
    </div>
  </div>
</template>

<script>
import { server } from '@/services/mixins';
import MatchResults from './MatchResults.vue';

export default {
  name: 'MatchInfoDouble',
  mixins: [server],
  components: { MatchResults },
  props: {
    matchId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      teamSeparator: '-',
    };
  },
  computed: {
    matchSportId() {
      return this.$store.getters.getMatchIdSport(this.matchId);
    },
    matchDisplayId() {
      return this.$store.getters.getMatchIdDisplay(this.matchId);
    },
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.matchId);
    },
    matchTeams() {
      return this.$store.getters.getMatchTeams(this.matchId);
    },
    matchPeriodInfo() {
      const { templateGrid } = this.$store.state;
      const matchTemplateInfo = this.$store.getters.getMatchTemplateInfo(this.matchId);
      const matchSection = templateGrid.matchSections[matchTemplateInfo][1];
      return matchSection ? matchSection.name : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-info {
  height: 100%;

  .match-info-teams {
    height: 100%;
    padding-right: $match-results-width;
  }

  .match-info-result {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: $match-results-width;
  }

  // Tennis
  &.match-sport-5 {
    .match-info-teams {
      padding-right: $match-results-width + $match-points-width;
    }
  }
}

.vertical-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: $match-vertical-line-width;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 1;
}

.match-display-id {
  float: left;
  width: $match-display-id-width;
  height: 100%;
  background-color: $match-id-color-back;
  font-weight: $font-weight-bold;
  font-size: 0.875rem;
}

.match-info-top,
.match-info-bottom {
  position: relative;
  height: 50%;
  width: 100%;
}

.match-info-top {
  padding-right: 180px;
  border-bottom: $match-bet-vertical-line-width solid
    $match-bet-vertical-line-color-back;
  .match-display-id {
    border-top-right-radius: 5px;
  }
}

.match-info-bottom {
  padding-right: 30px;
  font-size: 0.8125em;
  color: $color-important !important;
  .match-display-id {
    border-bottom-right-radius: 5px;
  }
  .border-cover {
    position: absolute;
    content: "";
    width: $match-display-id-width;
    height: $match-bet-vertical-line-width;
    top: -$match-bet-vertical-line-width;
    left: 0;
  }
}

.match-status {
  float: left;
  width: $match-status-width;
  height: 100%;
  color: $color-important;
  font-weight: $font-weight-bold;
  font-size: 0.8125rem;
}

.match-name {
  position: relative;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  &.pad-left {
    padding-left: $match-name-pad-left;
  }

  .team {
    position: relative;
    display: block;
    float: left;
    height: 100%;
    max-width: calc(50% - 15px);
    overflow: hidden;
    &:nth-child(2) {
      padding-left: 5px;
    }
  }

  .team-separator {
    display: block;
    float: left;
    width: $match-team-separator-width;
  }

  .important {
    color: $color-important;
  }
}

.card-wrapper {
  position: relative;
  padding: 0 13px;
  box-sizing: border-box;

  .card {
    position: absolute;
    width: 15px;
    height: 25px;
    line-height: 16px;
    border-width: 2px;
    border-style: solid;
    border-radius: 4px;
    background-color: $match-card-red;
    box-sizing: content-box;
  }

  .card-single {
    left: 3px;
    top: 0.4vh;
  }

  .card-multiple {
    display: inline-block;

    .card-multiple-1 {
      bottom: 0.15vh;
      left: 0;
    }
    .card-multiple-2 {
      top: 0.15vh;
      right: 0;
    }
    .card-count {
      color: $match-card-red-count-color;
      font-size: 0.5rem;
    }
  }
}

.server {
  position: absolute;
  left: 0;
  bottom: 0;
  width: $match-server-width;
  height: $match-server-height;
  border-top-left-radius: $match-server-height;
  border-top-right-radius: $match-server-height;
  background-color: $color-important-special;
}
</style>
